import React, { useEffect } from "react";
import "./Toast.css";

export default function Toast({ message, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 3000);
    return () => clearTimeout(t);
  }, [onDone]);

  return <div className="toast">{message}</div>;
}
